export default __webpack_public_path__ + "71a83f36edda71e9ca788b43d2a6b5ee.png";